import { setLocale } from '@thoughtspot/date-format-util';
import { dateFormats, getNewLocaleId, initializeDateFormats, } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
const logger = create('mfe-date-formats-init');
let initialized = false;
export function initializeMFEDateFormats(sessionService) {
    if (initialized || Object.keys(dateFormats).length > 0) {
        logger.log('MFE date-formats already initialized, skipping');
        return Promise.resolve();
    }
    const locale = sessionService.getPreferredLocale();
    const timezone = sessionService.getSessionTimeZone();
    const quarterStartMonth = sessionService.getQuarterStartMonth?.() ?? 1;
    const newLocaleId = getNewLocaleId(locale || undefined);
    return (initializeDateFormats(quarterStartMonth, timezone || undefined, locale || undefined)
        .then(() => setLocale(newLocaleId))
        .then(() => {
        initialized = true;
        logger.log('MFE date-formats initialized successfully');
        return undefined;
    })
        .catch((error) => {
        logger.error('Failed to initialize MFE date-formats:', error);
    }));
}
export function isMFEDateFormatsInitialized() {
    return initialized;
}
export function resetMFEDateFormatsInitialization() {
    initialized = false;
    logger.log('MFE date-formats initialization state reset');
}
//# sourceMappingURL=mfe-date-formats-init.js.map